import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import Carousel, { consts } from 'react-elastic-carousel';
import Right from '../../images/RIGHT.png';
import Left from '../../images/LEFT.png';
import translate from 'i18n/translate';
import { BASE_URL } from 'utils/constants';

export default function CompaniesCarousel() {
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    getCompanies();
  }, []);

  const myArrow = ({ type, onClick, isEdge }) => {
    const pointer =
      type === consts.PREV ? (
        <img alt="arrow" src={Left}></img>
      ) : (
        <img alt="arrow" src={Right}></img>
      );
    return (
      <div className="carousel-arrow" onClick={onClick} disabled={isEdge}>
        {pointer}
      </div>
    );
  };

  const getCompanies = () =>
    Axios.get(`${BASE_URL}/api/company?all=true`).then(({ data }) => {
      const filteredCompanies = data.filter(company => company.images !== null);
      setCompanies([...filteredCompanies]);
    });

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 450, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 }
  ];
  return (
    <div className="carousel">
      <div className="carousel-container">
        <h2>{translate('ourMembers')}</h2>
        <hr className="carousel-line" />
        <Carousel
          breakPoints={breakPoints}
          itemsToShow={3}
          renderArrow={myArrow}
          children={companies}
          renderPagination={({ pages, activePage, onClick }) => {
            return <div></div>;
          }}
        >
          {companies &&
            companies.map(company => (
              <div className="carousel-div" key={company.id}>
                <a
                  href={`http://${company.web && company.web.trim()}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    alt="carousel"
                    className="carousel-image"
                    src={`${BASE_URL}/${company.images.url}`}
                  />
                </a>
              </div>
            ))}
        </Carousel>
      </div>
    </div>
  );
}
